import React from "react";
import { Link } from "react-router-dom";
import salmansImage from "../../assets/images/salman.png";

export default function Hero() {
  return (
    <div className="bg-gradient-to-t from-neutral-100 to-neutral-200 dark:from-neutral-800 dark:to-neutral-900 pt-20">
      <div className="container px-4 mx-auto flex flex-col justify-center items-center lg:flex-row">
        <div className="lg:w-1/2 w-full flex flex-col justify-center items-center pt-20 lg:pt-0 lg:items-start gap-3">
          <h4 className="text-neutral-800 dark:text-neutral-400 font-semibold text-2xl">
            Hi there, I'm Salman
            {/* <span className="inline-block welcome-hand">👋</span> */}
            <span class="wave">👋</span>
          </h4>
          <h2 className="text-4xl text-neutral-900 dark:text-neutral-100 font-bold text-center lg:text-start">
            Front-End Web Developer
          </h2>
          <h4 className="text-neutral-800 dark:text-neutral-400 font-semibold text-2xl text-center lg:text-start">
            I empower people and brands to elevate their online presence through
            stunning and user-friendly web interfaces.
          </h4>
          <Link
            to="https://drive.google.com/file/d/1qNlicyNVr4rzSeKvur-t9n_eOXGlUN9P/view?usp=sharing"
            target="_blank"
            className="text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-2 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700"
          >
            View Resume
            <svg
              aria-hidden="true"
              className="w-5 h-5 ml-2 -mr-1"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
          </Link>
        </div>
        <div className="lg:w-1/2 w-full flex justify-center items-center">
          <img src={salmansImage} alt="" />
        </div>
      </div>
    </div>
  );
}
